
export function setHTML(id, html) {
  // const element = document.getElementById(id);

  // if (element.innerHTML != html)
  //   element.innerHTML = html;

  document.getElementById(id).innerHTML = html;
}


export function enableChildren(parentSelector, state){

  const childSelector = `${parentSelector} *`;

  const children = document.querySelectorAll(childSelector);

  children.forEach((element)=>(element.disabled = !state));
}

export function textAfterInput(event){

  const input = event.target;
  const currentText = event.target.value;

  var selectionStart = input.selectionStart;
  var selectionEnd = input.selectionEnd;

  const insertText = event.data ?? "";

  if ((event.data == null) && (selectionStart == selectionEnd))
    if (event.inputType.includes("Forward"))
      selectionEnd += 1;
    else if (event.inputType.includes("Backward"))
      selectionStart -= 1;

  const text1 = currentText.slice(0, selectionStart);
  const text2 = currentText.slice(selectionEnd);

  const newText = text1 + insertText + text2;

  return newText;
}

